import React, {Component} from 'react';
import $ from 'jquery';

const buttonStyle = {
    background: 'none',
    position: 'relative',
    top: '-34px'
};

const messageStyle = {
    marginTop: '20px'
};

class MailingListService {
    static postData(email) {
        return $.ajax({
            url: '/rest/mailing-list/' + email,
            type: 'put'
        });
    }
}

export default class MailingListForm extends Component {
    constructor(props) {
        super(props);
        this.state = {email: '', isSubmitting: false, submitSuccess: false, submitFailed: false};
        this.service = MailingListService;
    }

    emailChanged = e => {
        this.setState({email: e.target.value});
    };

    isValid = () => {
        return !!this.state.email;
    };

    submitEmail = () => {
        this.setState({isSubmitting: true});
        this.service.postData(this.state.email)
            .done(() => {
                this.setState({submitSuccess: true, email: ''});
            })
            .fail(e => {
                console.log('An error occurred submitting email address', e);
                this.setState({submitFailed: true});
            })
            .always(() => this.setState({isSubmitting: false}));
    };

    //noinspection JSMethodCanBeStatic
    render() {
        let button = null;
        if (!this.isValid() || this.state.isSubmitting) {
            button = <button type="button" className="btn btn-default pull-right" style={buttonStyle} disabled>Submit</button>
        } else {
            button = <button type="button" className="btn btn-default pull-right" style={buttonStyle} onClick={this.submitEmail}>Submit</button>
        }

        if (this.state.submitSuccess) {
            return <div className="alert alert-success" style={messageStyle}>Email submitted.</div>
        } else if (this.state.submitFailed) {
            return <div className="alert alert-danger" style={messageStyle}>A problem occurred.</div>
        } else {
            return (
                <form>
                    <div className="form-group">
                        <div style={{marginRight: '85px'}}>
                            <input type="email"
                                   className="form-control"
                                   id="email"
                                   placeholder="Email"
                                   value={this.state.email}
                                   onChange={this.emailChanged}/>
                        </div>
                        {button}
                    </div>
                </form>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/mailing-list-form.js